module.exports = __webpack_public_path__ + "img/collegevetmed-h-474x356.070ee7a0.jpg";